export const EmailRegexSingle = /^(?!.*@textmagic\.com\b)[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
